/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Fields_R2_Access_KeyInputs */

const en_admin_settings_fields_r2_access_key = /** @type {(inputs: Admin_Settings_Fields_R2_Access_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cloudflare Access Key`)
};

const zh_admin_settings_fields_r2_access_key = /** @type {(inputs: Admin_Settings_Fields_R2_Access_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cloudflare 访问密钥`)
};

/**
* | output |
* | --- |
* | "Cloudflare Access Key" |
*
* @param {Admin_Settings_Fields_R2_Access_KeyInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_settings_fields_r2_access_key = /** @type {((inputs?: Admin_Settings_Fields_R2_Access_KeyInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Fields_R2_Access_KeyInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_settings_fields_r2_access_key(inputs)
	return zh_admin_settings_fields_r2_access_key(inputs)
});
export { admin_settings_fields_r2_access_key as "admin.settings.fields.r2_access_key" }